import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { LayoutDashboard, Image, Beef, Newspaper, Settings, ExternalLink, LogOut } from "lucide-react";
import { api } from "../../lib/api";

const MENU = [
  ["/admin", "Dashboard", LayoutDashboard, true],
  ["/admin/banner", "Banner Event", Image],
  ["/admin/sapi", "Katalog Sapi", Beef],
  ["/admin/artikel", "Artikel Edukasi", Newspaper],
  ["/admin/pengaturan", "Pengaturan Situs", Settings],
];

const itemCls = ({ isActive }) =>
  `flex shrink-0 items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-[var(--gold)] text-[var(--forest-dark)]" : "text-white/75 hover:bg-white/10 hover:text-white"}`;

export default function AdminLayout() {
  const nav = useNavigate();
  const { data: user, isLoading, isError } = useQuery({
    queryKey: ["me"],
    queryFn: async () => (await api.get("/auth/me")).data,
    retry: false,
    enabled: !!localStorage.getItem("ss_token"),
  });
  const logout = () => {
    localStorage.removeItem("ss_token");
    nav("/admin/login");
  };
  if (!localStorage.getItem("ss_token") || isError) {
    localStorage.removeItem("ss_token");
    return <Navigate to="/admin/login" replace />;
  }
  if (isLoading) return <div className="grid min-h-screen place-items-center">Memuat...</div>;

  return (
    <div className="min-h-screen bg-[var(--cream)] lg:flex">
      <aside className="bg-[var(--forest-dark)] p-4 lg:sticky lg:top-0 lg:h-screen lg:w-64 lg:shrink-0 lg:p-6" data-testid="admin-sidebar">
        <div className="mb-4 flex items-center justify-between lg:mb-10 lg:block">
          <p className="font-display text-xl font-semibold text-white">Sembada<span className="text-[var(--gold)]">Satwa</span></p>
          <p className="text-xs text-white/50 lg:mt-1">Panel Admin · {user?.username}</p>
        </div>
        <nav className="flex gap-2 overflow-x-auto lg:flex-col">
          {MENU.map(([to, label, Icon, end]) => (
            <NavLink key={to} to={to} end={end} className={itemCls} data-testid={`admin-nav-${to.split("/")[2] || "dashboard"}`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
          <a href="/" target="_blank" rel="noreferrer" className={itemCls({})} data-testid="admin-nav-view-site"><ExternalLink className="h-4 w-4" /> Lihat Website</a>
          <button onClick={logout} className={itemCls({})} data-testid="admin-logout-button"><LogOut className="h-4 w-4" /> Keluar</button>
        </nav>
      </aside>
      <main className="flex-1 p-5 md:p-10">
        <Outlet />
      </main>
    </div>
  );
}

export const AdminHead = ({ title, desc, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
    <div>
      <h1 className="font-display text-3xl font-semibold text-[var(--forest-dark)]" data-testid="admin-page-title">{title}</h1>
      {desc && <p className="mt-1 text-sm text-[var(--ink)]/60">{desc}</p>}
    </div>
    {children}
  </div>
);
